/**
 * Get the window width.
 *
 * Get the width of the browser window or the client's device screen.
 *
 * @since ??
 *
 * @see https://vanillajstoolkit.com/reference/viewport/viewport-width/
 *
 * @returns {number} The width of the browser window or the client's device screen.
 */
export const getWindowWidth = (): number => window.innerWidth || document.documentElement.clientWidth;
